"use client";

import { useSpotifyWebPlayer } from "@/hooks/useSpotifyWebPlayer";

/**
 * Prewarms provider-specific playback infrastructure that benefits from
 * app-wide startup. Spotify needs its Web Playback SDK device registered
 * before the session UI asks for transport controls.
 */
export default function MediaPlayerBootstrap() {
  useSpotifyWebPlayer({
    autoTransfer: false,
    autoTransferPlay: false,
  });

  return null;
}
